/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
//import Table, { TableBody, TableCell, TableHead, TableRow } from '@material-ui/Table';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';

import CarLogo from '../CarLogo';

import CircularProgress from '@material-ui/core/CircularProgress';
import { removeDollarSign } from '../../helper';
import RatingStars from '../RatingStars';
import Footer from '../Footer';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  carImage: {
    maxWidth: '30%',
    [theme.breakpoints.up('sm')]: {
      'max-width': 160,
    },
    'max-height': 120,
    height: 'auto',
    width: 'auto',
  },
  listItem: {
    width: '100%',
    padding: '2px',
  },
  list: {
    width: '100%',
    padding: '2px',
    borderTop: '1px solid rgba(15,70,100,.12)',
  }
});

class Deals extends Component{

    handleDealClick = () => {
      //console.log('list item clicked');
    };

    // componentDidUpdate(prevProps) {
    //   // Typical usage (don't forget to compare props):
    //   if (this.props.list !== prevProps.list) {
    //     console.log('Deals: list changed. Len: ' + this.props.list.length);
    //   }
    // }

    render() {
        const { classes, list } = this.props;
        const sortedList = list.sort((a,b) => parseFloat(a['valueScore']) > parseFloat(b['valueScore'])?1:-1)

        return (
          <div className={classes.root}>

              {(list.length !== 0) ?
              <div className={classes.root}>

                <List className={classes.list}>
                  { list && sortedList.map((data, i) =>
                    <ListItem
                        key={i}
                        dense
                        button
                        className={classes.listItem}
                        onClick={this.handleDealClick}
                        component={Link} to={'/deals/detail/' + data.id}
                      >
                      <CarLogo brand={data.make}/>
                      <ListItemText id={data.created} primary={data.model} secondary={"$" + removeDollarSign(data.leaseMonthlyPayment) + "/month"} />
                      <RatingStars valueScore={data.valueScore} fontSize={true} />
                      <img src={data.offerImage} className={classes.carImage}  alt="" />
                    </ListItem>
                  )}
                </List>
                <div><br/></div>
                <Footer />
            </div> : <CircularProgress className={classes.progress} />}
          </div>
        );
    }
}

export default withStyles(styles)(Deals);

//<div className={classes.numberCircle}>{(i+1)}</div>



// WEBPACK FOOTER //
// ./src/components/dashboard/Deals.jsx